import React, { useState, useEffect } from "react";
import x from "../images/iPhone 15 Mockup, Perspective (1).png";
import MasterThesis from "../images/master-thesis-image.png";
import Thesis from "../images/Bilen_utanbakground.png";
import BlueLoops from "../images/blueloops/blueloops.png";
import Homepage1 from "../images/clouds/Asset 14@4x.png";
import Homepage2 from "../images/clouds/Asset 13@4x.png";
import Scroll from "./Scroll";
import "./HeroSection.css";
import ProjectComponent from "./ProjectComponent/ProjectComponent";
import { useMediaQuery } from "react-responsive";
import LoadingSpinner from "./loader/loader";

function HeroSection() {
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const [selfPresentationHeight] = useState("100vh");
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    const timer = setTimeout(() => setLoading(false), 2000); // 2s splash screen
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timer);
    };
  }, []);

  const handleScroll = () => {
    window.scrollTo({
      top: windowHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="hero-container">
      {loading ? (
        <div className="loading-container">
          {" "}
          <LoadingSpinner></LoadingSpinner>
        </div>
      ) : (
        <>
          <div
            className="self-presentation"
            style={{ height: selfPresentationHeight }}
          >
            {!isMobile && (
              <img
                src={Homepage2}
                alt="Homepage"
                className="homepage-image"
              ></img>
            )}
            <div className="presentation-text">
              <h1 className="head">Welcome to my Portfolio</h1>
              <p className="introduction">
                Hi! I'm Linnea a UX/UI designer and frontend developer.
              </p>
              <p className="introduction">
                Scroll down to see some of my work.
              </p>
              <div className="scroll-container" onClick={handleScroll}>
                <Scroll />
              </div>
            </div>

            {!isMobile && (
              <img
                src={Homepage1}
                alt="Homepage"
                className="homepage-image"
              ></img>
            )}
          </div>

          <div className="projects-section">
            <div className="projectContainer">
              <ProjectComponent
                imageSrc={MasterThesis}
                title="CANEA Chat"
                description="Developing a User-Friendly AI Chatbot"
                route="/caneachat"
              />
              <ProjectComponent
                imageSrc={x}
                title="FilmFriends"
                description="Developing an Intuitive Movie Selection App"
                route="/filmfriends"
              />
            </div>
            <div className="projectContainer">
              <ProjectComponent
                imageSrc={Thesis}
                title="Electric Vehicle"
                description="Designing an Environmental Conscious Vehicle"
                route="/thesis"
              />
              <ProjectComponent
                imageSrc={BlueLoops}
                title="BlueLoops"
                description="Developing a Website for Crochet Patterns"
                route="/blueloops"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default HeroSection;
